module.exports = __webpack_public_path__ + "img/setup.b8b3d652.png";